<div class="container">
  <div class="row">
    <div class="site-content shop-content-area col-sm-12" role="main">
      <div class="shop-loop-head">
        @if (loading()) {
          <p class="woocommerce-result-count">Loading products…</p>
        } @else {
          <p class="woocommerce-result-count">
            Showing {{ items().length }} of {{ totalCount() }} results
          </p>
        }
      </div>
      <div class="products elements-grid row">
        @for (item of items(); track item.id) {
          <app-product-card [product]="item" (add)="add($event)" />
        }
      </div>
      @if (hasMore()) {
        <div class="products-footer" style="text-align: center; margin: 2rem 0">
          <button
            type="button"
            class="btn btn-color-primary btn-style-default"
            [disabled]="loadingMore()"
            (click)="loadMore()"
          >
            {{ loadingMore() ? 'Loading…' : 'Load more' }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
